/**
 * @generated SignedSource<<6c09431aca96a62119036d44223da277>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BusinessBoard_withWorkflow_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BoardContentOld_project" | "BoardContent_project" | "BoardDataProvider_project" | "BoardHeader_project">;
  readonly " $fragmentType": "BusinessBoard_withWorkflow_project";
};
export type BusinessBoard_withWorkflow_project$key = {
  readonly " $data"?: BusinessBoard_withWorkflow_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"BusinessBoard_withWorkflow_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "BusinessBoard_withWorkflow_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BoardDataProvider_project"
    },
    {
      "kind": "FragmentSpread",
      "name": "BoardHeader_project"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "BoardContent_project"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "BoardContentOld_project"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "cf7f3e28759e5a01edceb22400d13143";

export default node;
